'use strict';

DoohApps
    .factory('PersonsData', ['restApi', function (restApi) {
        var controllerName = 'Company/';

        return {
            getPersonList: function (successCallback, objectFilterOptions) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetPersonFilterData', objectFilterOptions);
            },
            updatePerson: function (successCallback, person) {
                restApi.PutApiMethod(successCallback, controllerName + 'PutPerson', person);
            },
            deletePerson: function (successCallback, id) {
                restApi.DeleteApiMethod(successCallback, controllerName + 'DeletePerson?Id=' + id);
            },
            getTimeZones: function (successCallback) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetTimeZones');
            },
            getIANATimeZone: function (successCallback, timezoneID) {
                restApi.GetApiMethod(successCallback, controllerName + 'GetIanaTimeZone?windowsID=' + timezoneID);
            },

        }
    }]);
